<div class="page-container">
  <div class="header">
    <div class="row">
      <div>{{learnset?.name}}</div>
      <div class="score">{{cumulativeScore}} XP</div>
    </div>
    <div class="progress-bar">
      <div [style.width]="cardsProgress + '%'" class="progress-fill"></div>
    </div>
  </div>

  <app-flashcard *ngIf="currentFlashcard && !allCardsFinished" [flashcard]="currentFlashcard!" [side]="currentFlashcardSide"></app-flashcard>

  <app-success-screen *ngIf="allCardsFinished" [title]="'Alle Lernkarten gelernt'" [message]="'Super! Du hast alle Lernkarten in diesem Lernset gelernt!'" [buttonText]="'Lernmodus beenden'" (buttonClicked)="finishSession()"></app-success-screen>

  <div class="footer" *ngIf="!allCardsFinished">
    <ng-container *ngIf="!showFeedback">
      <app-loader *ngIf="isLoadingFeedback" [text]="'Antwort wird ausgewertet'" [center]="true"></app-loader>
      <button *ngIf="!showFeedback && !isLoadingFeedback" class="record-btn" (mousedown)="startRecording()" (mouseup)="stopRecording()">
        <tabler-icon name="microphone"></tabler-icon>
      </button>
    </ng-container>
    
    <ng-container *ngIf="showFeedback">
      <app-feedback-widget [title]="feedbackTitle!" [text]="feedbackMessage!" [score]="feedbackScore!" [color]="feedbackColor"></app-feedback-widget>
      <app-button [text]="'Nächste Lernkarte'" (clickEvent)="nextCard()"></app-button>
    </ng-container>
  </div>
</div>